import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error) {
    console.error("UI error:", error);
  }
  render() {
    if (!this.state.error) return this.props.children;
    const it = (localStorage.getItem("vantex_lang") || "en") === "it";
    return (
      <div className="min-h-screen bg-[#0A0D14] text-white flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md w-full rounded-2xl border border-[#243047] bg-[#121824] p-8 text-center">
          <h2 className="font-heading text-xl font-bold">{it ? "Qualcosa è andato storto" : "Something went wrong"}</h2>
          <p className="text-sm text-[#94A3B8] mt-2">
            {it ? "La pagina ha incontrato un errore, probabilmente per una versione non aggiornata dell'app. Ricarica per continuare." : "The page hit an error, probably due to an outdated app version. Reload to continue."}
          </p>
          <button onClick={() => window.location.reload()} data-testid="error-reload-button"
            className="mt-5 w-full rounded-lg bg-gradient-to-r from-[#EC1E9C] to-[#00FFC2] text-[#03110B] font-bold py-3 hover:brightness-110 transition">
            {it ? "Ricarica la pagina" : "Reload page"}
          </button>
        </div>
      </div>
    );
  }
}
